import styled from "styled-components";

const FooterCopyRightLinkContent = styled.div`
  margin-bottom: 5px;
  text-align: left;

  @media (max-width: 575px) {
    margin-bottom: 10px;
    text-align: center;
  }
`;
 export default FooterCopyRightLinkContent;